import type { FC } from "react";
import { useEffect, useRef } from "react";

import type { BreadcrumbsList } from "../../../Breadcrumbs";
import { Breadcrumbs } from "../../../Breadcrumbs";

// import { Container } from "@ui/eva-components/Container";
import styles from "./HeaderBreadcrumbs.module.scss";

type HeaderBreadcrumbsProps = {
  breadcrumbsList: BreadcrumbsList;
  useHeadingTagForBreadcrumbs?: boolean;
  expandBreadcrumbsLabel?: string;
};

const HEADER_BREADCRUMBS_HEIGHT_VARIABLE = "--header-breadcrumb-height";

export const HeaderBreadcrumbs: FC<HeaderBreadcrumbsProps> = ({
  breadcrumbsList,
  useHeadingTagForBreadcrumbs = true,
  expandBreadcrumbsLabel,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const updateHeight = () => {
      if (ref.current) {
        document.documentElement.style.setProperty(HEADER_BREADCRUMBS_HEIGHT_VARIABLE, `${ref.current.offsetHeight}px`);
      }
    };

    const resizeObserver = new ResizeObserver(updateHeight);

    if (ref.current) {
      resizeObserver.observe(ref.current);
    }

    return () => {
      resizeObserver.disconnect();
      document.documentElement.style.removeProperty(HEADER_BREADCRUMBS_HEIGHT_VARIABLE);
    };
  }, []);
  return (
    <div ref={ref}>
      <div className={styles.container}>
        <Breadcrumbs
          list={breadcrumbsList}
          useHeadingTag={useHeadingTagForBreadcrumbs}
          expandButtonLabel={expandBreadcrumbsLabel}
        />
      </div>
    </div>
  );
};
